export default __webpack_public_path__ + "static/media/WorkingNearWater.20006df0.pdf";